import React, { useCallback, useEffect } from "react";
import { Upload } from "../../icons";
import ImageUploading from "react-images-uploading";

import { Button } from "../index";
import * as Styled from "./multiple-upload.style";
import { assetUrl } from "../../helpers";

export const MultipleUpload = ({
  name,
  register,
  errors,
  label,
  getImages,
  defaultValue,
}) => {
  const [images, setImages] = React.useState([]);
  const maxNumber = 3;

  const formattedImageList = useCallback(
    (list) => list.map((item) => (item.dataURL ? item.dataURL : item)),
    []
  );
  const onChange = (imageList) => {
    setImages(formattedImageList(imageList));
    getImages(formattedImageList(imageList));
  };
  useEffect(() => {
    if (defaultValue) {
      setImages(defaultValue);
    }
  }, [defaultValue]);

  return (
    <>
      <Styled.Label>{label}</Styled.Label>
      <ImageUploading
        multiple
        value={images}
        onChange={onChange}
        maxNumber={maxNumber}
      >
        {({
          imageList,
          onImageUpload,
          onImageRemoveAll,
          onImageUpdate,
          onImageRemove,
          isDragging,
          dragProps,
        }) => (
          // One flowing row: the dropzone is now the same size as a preview
          // tile, so a two-column grid just stranded them apart.
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: 12,
              alignItems: "flex-start",
            }}
          >
            <Styled.UploadField
              style={isDragging ? { color: "red" } : undefined}
              onClick={onImageUpload}
              {...dragProps}
              role="button"
              register={register}
            >
              <Styled.Wrapper>
                <Styled.Icon>
                  <Upload />
                </Styled.Icon>
                <Styled.Text>
                  Drag and drop the image or click to select files
                </Styled.Text>
              </Styled.Wrapper>
            </Styled.UploadField>

            <Styled.ImagesPreview>
              {imageList &&
                imageList?.map((image, index) => (
                  <Styled.ImageWrapper key={index}>
                    {/* `image` is a data URL for a file just picked, or a
                        server-relative path for one already saved; assetUrl
                        resolves the latter against the API origin. alt is a
                        label, not the path -- it used to dump the whole
                        "/files/vouchers/..." string on screen when the image
                        failed to load. */}
                    <Styled.Image
                      src={assetUrl(image.dataURL || image)}
                      alt={`Voucher image ${index + 1}`}
                    />
                    <Button
                      variant="danger"
                      handleClick={() => onImageRemove(index)}
                    >
                      Remove
                    </Button>
                  </Styled.ImageWrapper>
                ))}
            </Styled.ImagesPreview>
          </div>
        )}
      </ImageUploading>

      {errors && errors[name] && (
        <p style={{ color: "#cd0303" }}>{errors[name].message}</p>
      )}
    </>
  );
};

export default MultipleUpload;
